// reducers/connect/register.js

export function connectRegisterHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_REGISTER_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectRegisterIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_REGISTER_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectRegister(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_REGISTER_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}